import { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import { TDispatch, TReduxStore } from '../../../shared/types/redux';
import { setModalOpen } from 'shared/slices/modal';
import { IJsonQueryPolygon } from 'packages/api-models/common/json_query';
import { removePolygon, selectPolygon } from 'shared/thunks/geo/polygon';
import { openGeoModal } from 'shared/slices/geo/slice';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/open-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setModalOpen(true)),
    },
    {
      path: '/v1/close-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setModalOpen(false)),
    },
    {
      path: '/v1/add-polygon-filter',
      handler: async (polygon: IJsonQueryPolygon) => (store.dispatch as TDispatch)(selectPolygon(polygon)),
    },
    {
      path: '/v1/remove-polygon-filter',
      handler: async () => (store.dispatch as TDispatch)(removePolygon()),
    },
    {
      path: '/v1/open-geo-modal',
      handler: async () => (store.dispatch as TDispatch)(openGeoModal()),
    },
  ];
}
